export function stripTypename(obj) {
    const { __typename, ...rest } = obj;
    return rest;
}
export function stripTypenames(arr) {
    return arr.map(stripTypename);
}
